import React from 'react';
import PropTypes from 'prop-types';
import { ChevronLeft, ChevronRight } from "lucide-react";

function Pagination({ currentPage, pageCount, setCurrentPage }) {
    const getPageNumbers = () => {
        const totalPageNumbers = 5;
        const startPage = Math.max(0, currentPage - Math.floor(totalPageNumbers / 2));
        const endPage = Math.min(pageCount - 1, startPage + totalPageNumbers - 1);

        let pageNumbers = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);

        if (startPage > 0) {
            pageNumbers.unshift(-1);
            pageNumbers.unshift(0);
        }
        if (endPage < pageCount - 1) {
            pageNumbers.push(-1);
            pageNumbers.push(pageCount - 1);
        }

        return pageNumbers;
    };

    return (
        <div className="px-4 py-3 flex flex-wrap items-center justify-between gap-2">
            <div className="text-sm text-gray-700">{`Page ${currentPage + 1} of ${pageCount}`}</div>

            <div className="flex justify-center flex-wrap">
                {getPageNumbers().map((pageNumber, index) => (
                    <button
                        key={index}
                        onClick={() => pageNumber !== -1 && setCurrentPage(pageNumber)}
                        className={`border border-gray-300 py-1 px-3 rounded-md mx-1 text-sm cursor-pointer transition-colors ${pageNumber === -1
                                ? "bg-gray-100 text-gray-500 cursor-default"
                                : currentPage === pageNumber
                                    ? "bg-blue-500 text-white border-blue-500 hover:bg-blue-600"
                                    : "text-gray-700 hover:bg-gray-100"
                            }`}
                        disabled={pageNumber === -1}
                    >
                        {pageNumber === -1 ? "..." : pageNumber + 1}
                    </button>
                ))}
            </div>

            {pageCount > 1 && (
                <div className="flex">
                    <button
                        className={`flex items-center text-sm py-2 px-3 rounded-md bg-blue-500 text-white border-none mr-2 hover:bg-blue-600 ${currentPage === 0 ? "opacity-50 cursor-not-allowed" : ""
                            }`}
                        disabled={currentPage === 0}
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 0))}
                    >
                        <ChevronLeft size={16} className="mr-1" />
                        Previous
                    </button>

                    <button
                        className={`flex items-center text-sm py-2 px-3 rounded-md bg-blue-500 text-white border-none hover:bg-blue-600 ${currentPage === pageCount - 1 ? "opacity-50 cursor-not-allowed" : ""
                            }`}
                        disabled={currentPage === pageCount - 1}
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, pageCount - 1))}
                    >
                        Next
                        <ChevronRight size={16} className="ml-1" />
                    </button>
                </div>
            )}
        </div>
    );
}

Pagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    setCurrentPage: PropTypes.func.isRequired,
};

export default Pagination;